import { LinkExternal01Icon } from '@langchain/untitled-ui-icons';

import useSWR from 'swr';

import Banner from '@/components/Banner';
import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';

import BraveLogo from './icons/brave.svg?react';
import SafariLogo from './icons/safari.svg?react';

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function isBrave() {
  if (
    !('brave' in navigator) ||
    typeof navigator.brave !== 'object' ||
    navigator.brave == null
  ) {
    return false;
  }

  if (
    !('isBrave' in navigator.brave) ||
    typeof navigator.brave.isBrave !== 'function'
  ) {
    return false;
  }

  return navigator.brave.isBrave();
}

export function GraphInitializeError(props: { error: unknown }) {
  const { data: isBraveOrSafari } = useSWR(
    ['graph', 'isBraveOrSafari'],
    async () => {
      if (await isBrave()) return 'brave';
      if (isSafari()) return 'safari';
      return null;
    }
  );

  const strError = props.error?.toString();

  if (
    isBraveOrSafari === 'brave' &&
    strError?.includes('TypeError: Failed to fetch')
  ) {
    return (
      <Banner
        open
        intent="error"
        title={
          <>
            <BraveLogo className="h-5 w-5" />
            <span>Using Brave?</span>
          </>
        }
        description={
          <p>
            Brave blocks access to <code>localhost</code> via <code>http</code>{' '}
            protocol when Brave Shields are up. Please disable Brave Shields to
            continue or relaunch the server with <code>--tunnel</code> flag.{' '}
            <a
              href="https://docs.langchain.com/langgraph-platform/troubleshooting-studio"
              className="inline-flex items-center gap-1 underline"
              target="_blank"
              rel="noreferrer"
            >
              Read more <LinkExternal01Icon className="h-4 w-4" />
            </a>
          </p>
        }
      />
    );
  }

  if (
    isBraveOrSafari === 'safari' &&
    strError?.includes('TypeError: Load failed')
  ) {
    return (
      <Banner
        open
        intent="error"
        title={
          <>
            <SafariLogo className="h-5 w-5" />
            <span>Using Safari?</span>
          </>
        }
        description={
          <p>
            Safari blocks access to <code>localhost</code> via <code>http</code>{' '}
            protocol by default. Please consider using a different browser or
            relaunch the server with <code>--tunnel</code> flag.{' '}
            <a
              href="https://docs.langchain.com/langgraph-platform/troubleshooting-studio"
              className="inline-flex items-center gap-1 underline"
              target="_blank"
              rel="noreferrer"
            >
              Read more <LinkExternal01Icon className="h-4 w-4" />
            </a>
          </p>
        }
      />
    );
  }

  return <ExpandableErrorAlert error={props.error} />;
}
